// 1. BACKEND BASE URL
// export const BACKEND_BASE_URL = 'http://192.168.100.15:7000'
export const BACKEND_BASE_URL = 'https://api.predixio.co'


// 2. PREDIXIO API URLS
export const LOGIN = '/api/web/login/'
export const REGISTER = '/api/web/member/register/'
export const NOTIFICATIONS = '/api/web/notification/'
export const UPDATE_MEMBER = '/api/web/member/app/'
export const COMPLETE_PROFILE = '/api/web/member/complete/'
export const CHANGE_PASSWORD = '/api/web/change-password/'
export const READ_ALL_NOTIFICATIONS = '/api/web/notifications/read/'
export const SUBSCRIPTION_PLANS = '/api/bet/web/subscription/'
export const MARKETS = '/api/bet/web/market/'
export const COVERED_LEAGUES = '/api/bet/competition/web/'
export const FAVOURITE_LEAGUES = '/api/bet/competition/favourite/'
export const MY_PREDICTIONS = '/api/prediction/my/predictions/'
export const PREDICT_FIXTURE_MARKET = '/api/prediction/market/predict/'
export const DASHBOARD_COUNTERS = '/api/prediction/dashboard/counters/'
export const DASHBOARD_YIMESERIES = '/api/prediction/dashboard/timeseries/'
export const FIZTURE_DETAILS = '/api/prediction/fixture/'

export const DASHBOARD_SUMMARY = "/api/dashboard/summary/"
export const PREDICTIONS_REPORT_OVERVIEW = "/api/report/web/predictions/overview/"
export const PREDICTIONS_REPORT_TIMESERIES = "/api/report/web/predictions/timeseries/"
export const BALANCE_REPORT_TIMESERIES = "/api/report/web/balance/timeseries/"
export const TRIPLE_PREDICTIONS = "/api/report/web/predictions/triple/"
export const PREDICTIONS_BY_MARKET = "/api/report/web/predictions/market/"
export const PREDICTIONS_BY_MARKET_OPTIONS = "/api/report/web/predictions/market/option/"

export const TOURNAMENT_SEASONS = 'https://www.sofascore.com/api/v1/team/2676/standings/seasons'
